var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInputTypePasswordVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46967 1.53033C1.17678 1.23744 1.17678 0.762563 1.46967 0.46967C1.76256 0.176777 2.23744 0.176777 2.53033 0.46967L18.5303 16.4697C18.8232 16.7626 18.8232 17.2374 18.5303 17.5303C18.2374 17.8232 17.7626 17.8232 17.4697 17.5303L14.6429 14.7036C13.2337 15.4709 11.66 16 10 16C6.18448 16 2.82549 13.2047 0.869705 11.1469C-0.289902 9.92683 -0.289902 8.07317 0.869706 6.8531C1.69953 5.98001 2.78196 4.97414 4.04468 4.10534L1.46967 1.53033ZM7.41536 7.47603C7.15145 7.92266 7 8.44364 7 9C7 10.6569 8.34315 12 10 12C10.5564 12 11.0773 11.8486 11.524 11.5846L7.41536 7.47603ZM10 2C13.8155 2 17.1745 4.79533 19.1303 6.8531C20.2899 8.07317 20.2899 9.92683 19.1303 11.1469C18.6902 11.6099 18.1791 12.1103 17.6078 12.6077L7.4127 2.41264C8.24217 2.15256 9.10863 2 10 2Z",
    fill: "#16191D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputTypePasswordVisible);
export default __webpack_public_path__ + "static/media/icon-input_type_password_visible.107527c401509efa8dbe5259ca91c283.svg";
export { ForwardRef as ReactComponent };